import { jsx as o, jsxs as t } from "react/jsx-runtime";
import { useState as l } from "react";
import { Popover as m } from "../../../../components/Popover/index.js";
import { ReactComponent as f } from "../../../../resources/graphics/comments/funny-icon.svg.js";
import { ReactComponent as v } from "../../../../resources/graphics/comments/like-icon.svg.js";
import { ReactComponent as C } from "../../../../resources/graphics/comments/helpful-icon.svg.js";
import { reactionsPopoverContainerStyle as h, Container as d, ReactButton as r } from "./styles.js";
import { ReactionType as i } from "../../types.js";
import { useTranslation as u } from "../../../../hooks/useTranslation/index.js";
const R = ({ onReactClick: n }) => {
  const { t: e } = u("common");
  return /* @__PURE__ */ t(d, { children: [
    /* @__PURE__ */ t(
      r,
      {
        onClick: () => {
          n(i.LIKE);
        },
        children: [
          /* @__PURE__ */ o(v, {}),
          /* @__PURE__ */ o("span", { children: e("reactions-popover-like") })
        ]
      }
    ),
    /* @__PURE__ */ t(
      r,
      {
        onClick: () => {
          n(i.FUNNY);
        },
        children: [
          /* @__PURE__ */ o(f, {}),
          /* @__PURE__ */ o("span", { children: e("reactions-popover-funny") })
        ]
      }
    ),
    /* @__PURE__ */ t(
      r,
      {
        onClick: () => {
          n(i.HELPFUL);
        },
        children: [
          /* @__PURE__ */ o(C, {}),
          /* @__PURE__ */ o("span", { children: e("reactions-popover-helpfull") })
        ]
      }
    )
  ] });
}, E = ({
  children: n,
  onReactClick: e,
  ...p
}) => {
  const [a, c] = l(!1);
  return /* @__PURE__ */ o(
    m,
    {
      isOpen: a,
      setIsOpen: c,
      content: /* @__PURE__ */ o(R, { onReactClick: (s) => {
        c(!1), e(s);
      } }),
      popoverContainerStyle: h,
      ...p,
      children: n
    }
  );
};
export {
  E as ReactionsPopover
};
